// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-vessel-eq[data-v-7fc2b400] .el-submenu__title {\n  border-bottom: none !important;\n}\n.tab-vessel-eq .warn-label .el-form-item__label[data-v-7fc2b400] {\n  color: orange !important;\n}\n.tab-vessel-eq .mbl-red .el-input__inner[data-v-7fc2b400] {\n  color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
